import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import LogoWithHomeLink from "../../../components/LogoWithHomeLink";
import { useState } from "react";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

export default function TermsConditions() {
  const [termsConditionsAccepted, setTermsConditionsAccepted] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleChange = (event) => {
    setTermsConditionsAccepted(event.target.checked);
  };

  const handleSubmit = () => {
    if (termsConditionsAccepted) {
      navigate("/registration/initiate");
    } else {
      toast.error(t("notifications.accept_terms_conditions"));
    }
  };

  return (
    <>
      <Helmet>
        <title>{t("pages.registration.terms_conditions.title")}</title>
      </Helmet>

      <div className="flex flex-col flex-1 w-full">
        <LogoWithHomeLink />

        <div className="justify-center w-full sm:max-w-3/4 mx-auto mt-5 mb-24 sm:mb-24">
          {/* <div className="justify-center w-full max-w-3/4 mx-auto mt-5"> */}
          <div className="mb-5 sm:mb-8">
            <h1 className="mb-2 font-semibold text-gray-800 text-title-sm dark:text-white/90 sm:text-title-md">
              {t("pages.registration.terms_conditions.page_title")}
            </h1>

            <div className="mb-6 sm:mb-8 ml-2">
              <p className="text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  1. Introduction
                </strong>
                <br />
                These Terms and Conditions (“Terms”) govern the use of the Video
                Know Your Customer (“Video KYC”) system (“System”) provided by
                [Company Name] (“Service Provider”) to verify the identity of
                customers (“User”) on behalf of financial institutions
                (“Institution”). By accessing or using the System, the User
                agrees to be bound by these Terms.
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  2. Purpose of Video KYC
                </strong>
                <br />
                The System is designed to facilitate remote identity
                verification in compliance with applicable Know Your Customer
                (KYC), Anti-Money Laundering (AML), and Counter-Terrorist
                Financing (CTF) regulations. The System does not replace the
                regulatory obligations of the Institution but acts as a
                supporting verification mechanism.
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  3. User Consent
                </strong>
                <br />
                By participating in the Video KYC process, the User expressly
                consents to live video and audio recording, capture of images,
                identity documents, and biometric data (where permitted by law),
                and the processing and storage of personal data for identity
                verification and compliance purposes. If consent is not
                provided, the Video KYC process cannot be completed.
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  4. Data Collection and Use
                </strong>
                <br />
                The System may collect personal identification details,
                government-issued identity documents, facial images, video
                recordings, and metadata related to the verification session.
                This data is used solely for identity verification, regulatory
                compliance, fraud prevention, and audit and record-keeping
                requirements, in accordance with applicable data protection laws
                and the Service Provider’s Privacy Policy.
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  5. Data Storage and Retention
                </strong>
                <br />
                Video KYC records shall be securely stored and retained for the
                period required under applicable laws or regulatory guidelines,
                after which they will be securely deleted or anonymized unless
                further retention is legally required.
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  6. User Responsibilities
                </strong>
                <br />
                The User agrees to provide accurate, complete, and truthful
                information, present valid and original identity documents,
                participate in the process without impersonation or
                misrepresentation, and ensure a stable internet connection and
                suitable environment during verification. Any false or
                misleading information may result in rejection of the KYC
                process.
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  7. System Availability and Limitations
                </strong>
                <br />
                While reasonable efforts are made to ensure system availability,
                the Service Provider does not guarantee uninterrupted or
                error-free operation and shall not be liable for delays or
                failures caused by technical issues, network problems, or force
                majeure events.
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  8. Confidentiality and Security
                </strong>
                <br />
                Appropriate technical and organizational measures are
                implemented to protect data against unauthorized access, loss,
                or misuse. Access to Video KYC data is restricted to authorized
                personnel only.
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  9. Third-Party Access
                </strong>
                <br />
                Video KYC data may be shared with the requesting Institution,
                regulatory or law enforcement authorities where legally
                required, and authorized service partners subject to
                confidentiality obligations. No data shall be sold or shared for
                marketing purposes without explicit user consent.
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  10. Limitation of Liability
                </strong>
                <br />
                To the maximum extent permitted by law, the Service Provider
                shall not be liable for decisions taken by the Institution based
                on Video KYC results, any indirect, incidental, or consequential
                damages, or losses arising from incorrect information provided
                by the User.
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  11. Modification of Terms
                </strong>
                <br />
                These Terms may be updated from time to time to reflect changes
                in legal, regulatory, or operational requirements. Continued use
                of the System constitutes acceptance of the updated Terms.
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  12. Governing Law and Jurisdiction
                </strong>
                <br />
                These Terms shall be governed by and construed in accordance
                with the laws of [Jurisdiction]. Any disputes shall be subject
                to the exclusive jurisdiction of courts located in [Location].
              </p>

              <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">
                <strong className="text-gray-800 dark:text-white/90">
                  13. Contact Information
                </strong>
                <br />
                For questions or concerns regarding these Terms or the Video KYC
                process, please contact:
                <br />
                Email: support@company.com
                <br />
                Address: [Company Address]
              </p>
            </div>
          </div>

          <div>
            <div className="space-y-5">
              <div className="my-2">
                <label className="text-gray-500 dark:text-gray-400 flex align-center gap-2">
                  <input
                    type="checkbox"
                    value={1}
                    checked={termsConditionsAccepted}
                    onChange={handleChange}
                  />
                  {t("pages.registration.terms_conditions.controllers.accept")}
                </label>
              </div>
              <button
                onClick={handleSubmit}
                className="flex items-center justify-center px-10 py-3 mt-8 text-sm font-medium text-white transition rounded-lg bg-brand-500 shadow-theme-xs hover:bg-brand-600"
              >
                {t("buttons.continue")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
